export const GETALLSELECTS = "GETALLSELECTS";
export const GETALLSELECTSSAGA = "GETALLSELECTSSAGA";

export const GETALLFILTERS = "GETALLFILTERS";
export const GETALLFILTERSSAGA = "GETALLFILTERSSAGA";

export const SETFILTERS = "SETFILTERS";
export const SETFILTERSSAGA = "SETFILTERSSAGA";
